import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizEntry;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import pick from 'lodash/pick';
import partial from 'lodash/partial';
import ReactDOM from 'react-dom';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import WarningWrapper from '../../../../../common/components/resources/WarningWrapper';
import { propsForItemBankEntryEditPrompt, propsForStimulusBankEntryEditPrompt, propsForBankEntryUnauthorizedEdit, propsForItemVersioningWrapper, propsForBankEntryVersioningWrapper } from '../../../../../common/util/warningHelpers';
import QuizEntryRecord from '../../../../../common/records/QuizEntry';
import QuizEntryBankShow from '../QuizEntryBank/QuizEntryBankShow';
import QuizEntryBankEdit from '../QuizEntryBank/QuizEntryBankEdit';
import ItemEdit from '../../../../../common/components/resources/item/ItemEdit';
import ItemShow from '../../../../../common/components/resources/item/ItemShow';
import ItemOverride from '../../../../../common/components/resources/item/ItemOverride';
import AddToBankOptions from '../../AddToBankOptions';
import TagDisplay from '../../../../../common/components/shared/TagDisplay';
import Item from '../../../../../common/records/Item';
import { BUILD_TRAY_OPEN, PARENT_TYPE_QUIZ, REGRADE_MODAL, SHOULD_CLONE_ITEM, withStyleOverrides } from '@instructure/quiz-common';
import QuizEntryShow from '../QuizEntryShow';
import QuizEntryEdit from '../QuizEntryEdit';
import Stimulus from '../../../../../common/components/resources/stimulus/Stimulus';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var QuizEntry = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntry = /*#__PURE__*/function (_Component) {
  function QuizEntry() {
    var _this2;
    _classCallCheck(this, QuizEntry);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizEntry, [].concat(_args));
    _defineProperty(_this2, "itemOverrideTypes", function () {
      return ['choice'].concat(_toConsumableArray(_this2.props.partialScoringEnabled ? ['multi-answer'] : []), _toConsumableArray(_this2.props.partialDeepScoringEnabled ? ['matching'] : []));
    });
    _defineProperty(_this2, "openRegradeModal", function () {
      if (_this2.props.regradingOn) {
        _this2.props.openModal(REGRADE_MODAL);
      }
    });
    _defineProperty(_this2, "renderItemBankingOptions", function () {
      return jsx(AddToBankOptions, {
        displayPosition: _this2.props.displayPosition,
        entryType: _this2.props.quizEntry.entryType,
        focusFirstErrorField: _this2.focusFirstErrorField,
        guid: _this2.props.guid,
        isValid: _this2.props.workingEntry.isValid(),
        openModal: _this2.props.openModal,
        screenreaderNotification: _this2.props.screenreaderNotification,
        showError: _this2.props.showError,
        "data-automation": "sdk-item-banking-options"
      });
    });
    _defineProperty(_this2, "storeDndComponentRef", function (node) {
      _this2.dndComponent = node;
    });
    _defineProperty(_this2, "handleQuizEntryPointsChange", function (points) {
      _this2.props.changeQuizEntryPoints(_this2.props.quizEntry.id, points);
    });
    _defineProperty(_this2, "handleRef", function (node) {
      _this2.itemEditArea = node;
    });
    _defineProperty(_this2, "focusFirstErrorField", function () {
      if (_this2.itemEditArea) {
        var editArea = ReactDOM.findDOMNode(_this2.itemEditArea);
        var firstErrorField = editArea === null || editArea === void 0 ? void 0 : editArea.querySelector('[aria-invalid="true"]');
        firstErrorField && firstErrorField.focus();
      }
    });
    _defineProperty(_this2, "renderPrintableItemBankSample", function (sampleItem, index) {
      var quizEntry = QuizEntryRecord.create(sampleItem.toObject());
      var entryMutable = quizEntry.entry.toJS();
      var item = Item.create(entryMutable);
      var overrideProps = _objectSpread(_objectSpread({}, _this2.props), {}, {
        quizEntry: quizEntry,
        entry: item,
        displayPosition: _this2.props.displayPosition + index,
        interactionTypeName: entryMutable.interactionType.name
      });
      return jsx("div", {
        key: index,
        css: _this2.props.styles.sampleItems
      }, jsx(QuizEntryShow, overrideProps, jsx(ItemShow, _this2.propsForItem(item))));
    });
    _defineProperty(_this2, "bankEntryWarningWrapperProps", function () {
      if (_this2.props.quizEntry.entryEditable) {
        var _this2$props$entry;
        var isPassage = (_this2$props$entry = _this2.props.entry) === null || _this2$props$entry === void 0 ? void 0 : _this2$props$entry.passage;
        var propsFunc = _this2.props.quizEntry.hasStimulus ? function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          return propsForStimulusBankEntryEditPrompt.apply(void 0, [isPassage].concat(args));
        } : propsForItemBankEntryEditPrompt;
        return propsFunc(_this2.isEditing(), _this2.props.switchOffEditing, function () {
          var bankEntry = _this2.props.quizEntry.getEntry();
          _this2.props.setUi(BUILD_TRAY_OPEN, true);
          _this2.props.newActiveBankEntry(bankEntry.id, bankEntry.bankId);
          _this2.props.newActiveBank(bankEntry.bankId);
          _this2.props.switchOffEditing();
        });
      }
      return propsForBankEntryUnauthorizedEdit(_this2.isEditing());
    });
    return _this2;
  }
  _inherits(QuizEntry, _Component);
  return _createClass(QuizEntry, [{
    key: "additionalEditOptions",
    value: function additionalEditOptions(item) {
      var options = [];
      if (this.props.quizEntry.entryType === 'Item') {
        options.push({
          key: 'banks',
          title: t('Item Banking'),
          component: this.renderItemBankingOptions()
        });
      }
      return options;
    }
  }, {
    key: "propsForItem",
    value: function propsForItem() {
      var customItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var item = customItem || this.props.entry;
      return {
        additionalOptions: this.additionalEditOptions(item),
        entry: item,
        guid: customItem ? customItem.id : this.props.guid,
        handleQuizEntryPointsChange: this.handleQuizEntryPointsChange,
        parentId: this.props.quizId,
        parentType: PARENT_TYPE_QUIZ,
        switchOffEditing: this.props.switchOffEditing,
        switchOnEditing: this.props.switchOnEditing,
        title: item.title,
        initialFocusId: this.props.initialFocusId,
        validationErrorsFromApi: this.props.validationErrorsFromApi,
        clearValidationErrorsFromApi: this.props.clearValidationErrorsFromApi,
        separatorConfig: this.props.separatorConfig
      };
    }
  }, {
    key: "quizEntryProps",
    value: function quizEntryProps() {
      var entry = this.props.entry;
      return Object.assign({
        entry: entry,
        openRegradeModal: this.openRegradeModal,
        name: entry.getInteractionType().name,
        initialFocusId: this.props.initialFocusId,
        handleValidationErrorsFromApi: this.props.handleValidationErrorsFromApi,
        clearValidationErrorsFromApi: this.props.clearValidationErrorsFromApi,
        haveValidationErrorsFromApi: Boolean(Object.values(this.props.validationErrorsFromApi).length),
        itemEditArea: this.itemEditArea
      }, pick(this.props, ['displayPosition', 'guid', 'draggingOnBuild', 'newHoverPosition', 'quizEntry', 'quizEntries', 'quizId', 'isContentLockedByBlueprint', 'setUi', 'switchOffEditing', 'switchOnEditing', 'shouldClone', 'scrollKey', 'editQuizEntryToggle', 'onEditQuizEntryToggle', 'stimulusOrientation']));
    }
  }, {
    key: "isEditing",
    value: function isEditing() {
      var isTemporary = this.props.entry.isTemporary && this.props.entry.isTemporary();
      return this.props.isEditing || isTemporary;
    }
  }, {
    key: "renderItem",
    value: function renderItem() {
      var isEditing = this.isEditing();
      var _this$props = this.props,
        entry = _this$props.entry,
        shouldClone = _this$props.shouldClone,
        quizEntry = _this$props.quizEntry;
      var QuizEntryComponent = isEditing ? QuizEntryEdit : QuizEntryShow;
      var ItemComponent = isEditing && (!entry.isImmutable() || shouldClone) ? ItemEdit : ItemShow;
      var itemProps = this.propsForItem();
      var quizEntryProps = this.quizEntryProps();
      var propsForWrapperFunc = quizEntry.isArchivedBankEntry ? propsForBankEntryVersioningWrapper : propsForItemVersioningWrapper;
      var propsForItemVersioning = propsForWrapperFunc(entry.isImmutable() || quizEntry.isArchivedBankEntry, shouldClone, partial(this.props.setUi, SHOULD_CLONE_ITEM), this.props.switchOffEditing, isEditing, quizEntry.isArchivedBankEntry ? 'info' : 'warning');
      return jsx(QuizEntryComponent, quizEntryProps, jsx(WarningWrapper, propsForItemVersioning, jsx(ItemComponent, itemProps)));
    }
  }, {
    key: "renderBank",
    value: function renderBank() {
      var QuizEntryComponent = this.props.isEditing ? QuizEntryEdit : QuizEntryShow;
      var QuizEntryBankComponent = this.props.isEditing ? QuizEntryBankEdit : QuizEntryBankShow;
      var bank = this.props.workingQuizEntry.getEntry();
      var bankProps = {
        title: bank.title,
        entry: bank,
        name: bank.title
      };
      var sampleItems = this.props.quizEntry.sampleItems;
      return jsx("div", null, jsx("div", {
        css: this.props.styles.bankItem
      }, jsx(QuizEntryComponent, Object.assign({}, this.props, bankProps), jsx(QuizEntryBankComponent, Object.assign({}, this.props, bankProps)))), sampleItems.map(this.renderPrintableItemBankSample));
    }
  }, {
    key: "isOverridable",
    value: function isOverridable() {
      if (typeof this.props.entry.getInteractionType !== 'function') return false;
      return this.itemOverrideTypes().includes(this.props.entry.getInteractionType().slug);
    }
  }, {
    key: "isOverriding",
    value: function isOverriding() {
      return this.isOverridable() && this.isEditing();
    }
  }, {
    key: "renderBankEntry",
    value: function renderBankEntry() {
      var bankEntryWarningWrapperProps = this.bankEntryWarningWrapperProps();
      if (this.props.quizEntry.hasStimulus) {
        return this.renderStimulus(this.bankEntryWarningWrapperProps);
      }
      var overrideProps = {
        title: this.props.entry.title,
        isBankedContent: true
      };
      var quizEntryProps = Object.assign({}, this.props, overrideProps);
      var QuizEntryComponent = this.isEditing() ? QuizEntryEdit : QuizEntryShow;
      var itemProps = this.propsForItem();
      var mergedItem = this.isEditing() ? this.props.workingQuizEntry.getItem() : itemProps.entry;
      var ItemComponent = this.isOverriding() ? ItemOverride : ItemShow;
      return jsx(QuizEntryComponent, quizEntryProps, jsx(WarningWrapper, Object.assign({}, bankEntryWarningWrapperProps, {
        disableChildren: this.isEditing() && !this.isOverridable()
      }), jsx(ItemComponent, Object.assign({}, itemProps, {
        entry: mergedItem,
        quizEntry: this.props.quizEntry
      }))), this.renderFooter());
    }
  }, {
    key: "renderStimulus",
    value: function renderStimulus(bankEntryWarningWrapperProps) {
      return jsx(Stimulus, {
        bankEntryWarningWrapperProps: bankEntryWarningWrapperProps,
        childEntries: this.props.childEntries,
        displayPosition: this.props.displayPosition,
        dndRef: this.storeDndComponentRef,
        guid: this.props.guid,
        isBankedContent: bankEntryWarningWrapperProps !== void 0,
        isContentLockedByBlueprint: this.props.isContentLockedByBlueprint,
        isEditing: this.isEditing(),
        draggingOnBuild: this.props.draggingOnBuild,
        newHoverPosition: this.props.newHoverPosition // used for DnD
        ,
        propsForQuizEntry: this.props.propsForQuizEntry,
        quizEntry: this.props.quizEntry,
        quizEntries: this.props.quizEntries,
        quizId: this.props.quizId,
        scrollKey: this.props.scrollKey,
        shouldClone: this.props.shouldClone,
        stimulus: this.props.entry,
        switchOnEditing: this.props.switchOnEditing,
        switchOffEditing: this.props.switchOffEditing,
        editStimulusToggle: this.props.editQuizEntryToggle,
        onEditStimulusToggle: this.props.onEditQuizEntryToggle
      });
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      return jsx(TagDisplay, {
        tagAssociations: this.props.tagAssociations
      });
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (!this.props.useBankTags) {
        return null;
      }

      // Footer currently only contains tags, so don't render if no tags
      if (this.props.tagAssociations == null || this.props.tagAssociations.isEmpty()) {
        return null;
      }
      return jsx("div", {
        css: this.props.styles.footer
      }, this.renderTags());
    }
  }, {
    key: "renderQuizEntryByType",
    value: function renderQuizEntryByType() {
      if (this.props.quizEntry.isArchivedBankEntry) {
        if (this.props.quizEntry.hasStimulus) {
          return this.renderStimulus();
        } else {
          return this.renderItem();
        }
      }
      if (this.props.quizEntry.isItem) {
        return this.renderItem();
      } else if (this.props.quizEntry.isBankEntry) {
        return this.renderBankEntry();
      } else if (this.props.quizEntry.isBank) {
        return this.renderBank();
      } else if (this.props.quizEntry.isStimulus) {
        return this.renderStimulus();
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.connectDropTarget(jsx("div", {
        tabIndex: "-1",
        ref: this.handleRef
      }, this.renderQuizEntryByType()));
    }
  }]);
}(Component), _defineProperty(_QuizEntry, "displayName", 'QuizEntry'), _defineProperty(_QuizEntry, "componentId", "Quizzes".concat(_QuizEntry.displayName)), _defineProperty(_QuizEntry, "propTypes", {
  changeQuizEntryPoints: PropTypes.func.isRequired,
  childEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record),
  connectDropTarget: PropTypes.func.isRequired,
  // injected by DnD
  displayPosition: PropTypes.number.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  guid: PropTypes.string.isRequired,
  initialFocusId: PropTypes.string,
  isEditing: PropTypes.bool,
  draggingOnBuild: PropTypes.bool,
  newActiveBank: PropTypes.func.isRequired,
  newActiveBankEntry: PropTypes.func.isRequired,
  newHoverPosition: PropTypes.func.isRequired,
  // used for DnD
  openModal: PropTypes.func.isRequired,
  partialDeepScoringEnabled: PropTypes.bool,
  partialScoringEnabled: PropTypes.bool,
  propsForQuizEntry: PropTypes.func.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string.isRequired,
  isContentLockedByBlueprint: PropTypes.bool.isRequired,
  regradingOn: PropTypes.bool.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  scrollKey: PropTypes.string,
  setUi: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool,
  showError: PropTypes.func.isRequired,
  switchOffEditing: PropTypes.func.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  tagAssociations: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  useBankTags: PropTypes.bool,
  workingEntry: ImmutablePropTypes.record.isRequired,
  workingQuizEntry: ImmutablePropTypes.record.isRequired,
  editQuizEntryToggle: PropTypes.bool.isRequired,
  onEditQuizEntryToggle: PropTypes.func.isRequired,
  handleValidationErrorsFromApi: PropTypes.func.isRequired,
  clearValidationErrorsFromApi: PropTypes.func.isRequired,
  validationErrorsFromApi: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string
  }))),
  stimulusOrientation: PropTypes.string,
  separatorConfig: PropTypes.shape({
    decimalSeparator: PropTypes.string,
    thousandSeparator: PropTypes.string
  }),
  styles: PropTypes.object
}), _defineProperty(_QuizEntry, "defaultProps", {
  childEntries: List(),
  draggingAboveHalf: false,
  draggingOnBuild: false,
  draggingOver: false,
  initialFocusId: null,
  isContentLockedByBlueprint: false,
  isEditing: false,
  partialDeepScoringEnabled: false,
  partialScoringEnabled: false,
  scrollKey: void 0,
  shouldClone: false,
  tagAssociations: List(),
  useBankTags: false,
  validationErrorsFromApi: {},
  stimulusOrientation: null
}), _QuizEntry)) || _class);
export default QuizEntry;